// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".chat-mobile[data-v-3a0754ee]{position:absolute;right:4rem;top:12rem}.chat-desktop[data-v-3a0754ee]{position:absolute;right:10rem;top:2rem}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
